import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from '../../../components/LogoIcon';

const PlaceholderLink: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="hp-footer-placeholder" role="link" aria-disabled="true">
    {children}
  </span>
);

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="hp-footer">
      <div className="hp-footer-inner">
        <div className="hp-footer-grid">
          {/* Brand */}
          <div className="hp-footer-col hp-footer-brand">
            <div className="hp-footer-logo">
              <Logo height={36} textColor="white" />
            </div>
            <p>{t('footer.brandDescription')}</p>
          </div>

          {/* Produkt */}
          <div className="hp-footer-col">
            <h4>{t('footer.product')}</h4>
            <a href="#features">Features</a>
            <a href="#methods">{t('navbar.links.methods')}</a>
            <a href="#integrations">{t('navbar.links.integrations')}</a>
            <a href="#pricing">{t('navbar.links.pricing')}</a>
          </div>

          {/* Support */}
          <div className="hp-footer-col">
            <h4>{t('footer.support')}</h4>
            <Link to="/kontakt">{t('footer.contactForm')}</Link>
            <Link to="/status">{t('footer.systemStatus')}</Link>
            <Link to="/changelog">{t('footer.changelog')}</Link>
            <Link to="/hilfe">{t('footer.helpCenter')}</Link>
          </div>

          {/* Kontakt */}
          <div className="hp-footer-col">
            <h4>{t('footer.contact')}</h4>
            <a href="mailto:info@coachdesk365.com">info@coachdesk365.com</a>
            <a href="mailto:support@coachdesk365.com">support@coachdesk365.com</a>
          </div>
        </div>

        <div className="hp-footer-bottom">
          <span>{t('footer.copyright')}</span>
          <div className="hp-footer-legal">
            <Link to="/impressum">{t('footer.impressum')}</Link>
            <Link to="/datenschutz">{t('footer.datenschutz')}</Link>
            <Link to="/avv">AVV</Link>
            <Link to="/agb">AGB</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
